import React from "react";

import { Button } from "@iwoca/orion";
import { Trans } from "@lingui/react/macro";
import { useNavigate } from "react-router";

import TokenContainer from "./TokenContainer";
import styles from "./TokenContainer.module.css";
import TokenExpiredSVG from "../../assets/TokenAssets/TokenExpiredSVG";

type Props = {
  ctaUrl: string;
};
const TokenExpired: React.FunctionComponent<Props> = ({ ctaUrl }) => {
  const navigate = useNavigate();
  return (
    <TokenContainer data-testid="token-expired-view">
      <TokenExpiredSVG className={styles.tokenIllustration} />

      <h1 className={styles.tokenResponseTitle}>
        <Trans>Uh oh, time's up</Trans>
      </h1>

      <div className={styles.tokenReponseDescription}>
        <Trans>It's been more than an hour, so your link's expired.</Trans>
      </div>

      <Button
        variant="primary"
        onClick={() => navigate(ctaUrl)}
        className={styles.tokenResponseCTA}
      >
        <Trans>Start again with a new link</Trans>
      </Button>
    </TokenContainer>
  );
};

export default TokenExpired;
